import GridCards from "componentsv2/card/GridCards";
import CardFolio from "./CardFolio";
import { layout as layoutFolio } from "../models/folio";

function CheckGrid({ title, records, isLoading, refetch }) {
  const layout = layoutFolio();

  return (
    <div className="mt-4 border-2 border-dashed border-neutral-300 rounded-md p-4">
      <div className="flex">
        <span className="text-4xl font-bold text-neutral-400 mr-3">
          {title}
        </span>
        <div className="flex text-lg h-8 w-8 text-white rounded-full font-bold bg-neutral-300">
          <span className="m-auto">{records ? records.length : 0}</span>
        </div>
      </div>
      {!isLoading && records && (
        <GridCards
          layout={layout}
          model={layout.model}
          records={records}
          Card={CardFolio}
          reload={refetch}
        />
      )}
    </div>
  );
}

export default CheckGrid;
